import './IpadCarousel.css';

import iPad2026 from '../../../assets/apple/iPad/iPad2026/iPad26_1.png';
import iPadAir2026 from '../../../assets/apple/iPad/iPad2026/iPadAir_1.png';
import iPadPro2026 from '../../../assets/apple/iPad/iPad2026/iPadPro.png';

import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { useNavigate } from 'react-router-dom';

const iPadSlides = [
  {
    key: 'ipad',
    title: 'iPad',
    price: 'Starts at Rs. 34,900',
    emi: 'or No Cost EMI at Rs. 1,828 p.m.',
    image: iPad2026,
    imageClass: 'ipad2026-image ipad2026-image-a16',
    productId: 15,
    slideClass: 'ipad2026-slide ipad2026-slide-base',
  },
  {
    key: 'ipadair',
    title: 'iPad Air',
    price: 'Starts at Rs. 64,900',
    emi: 'or No Cost EMI at Rs. 3,606 p.m.',
    image: iPadAir2026,
    imageClass: 'ipad2026-image',
    productId: 11,
    slideClass: 'ipad2026-slide ipad2026-slide-air',
  },
  {
    key: 'ipadpro',
    title: 'iPad Pro',
    price: 'Starts at Rs. 99,900',
    emi: 'or No Cost EMI at Rs. 5,550 p.m.',
    image: iPadPro2026,
    imageClass: 'ipad2026-image',
    productId: 7,
    slideClass: 'ipad2026-slide ipad2026-slide-pro',
  },
];

const IpadCarousel = () => {
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);

  const pauseAutoplay = () => {
    swiperInstance?.autoplay?.stop();
  };

  const resumeAutoplay = () => {
    swiperInstance?.autoplay?.start();
  };

  const handleViewDetails = (productId) => {
    navigate(`/applestore/iphone-products-list/iphone-detail-page/ipad/${productId}`);
  };

  return (
    <Swiper
      modules={[Pagination, Navigation, Autoplay]}
      navigation
      pagination={{ type: 'progressbar', clickable: true }}
      slidesPerView={1}
      spaceBetween={0}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      style={{ padding: '0 0 3% 0', borderRadius: '40px' }}
      onSwiper={(swiper) => setSwiperInstance(swiper)}
    >
      {iPadSlides.map((slide) => (
        <SwiperSlide key={slide.key}>
          <section className={slide.slideClass}>
            <div className="ipad2026-content">
              <h1 className="ipad2026-title">{slide.title}</h1>
              <h2 className="ipad2026-subtitle">{slide.price}</h2>
              <p className="ipad2026-emi">{slide.emi}</p>

              <div className="ipad2026-image-wrapper">
                <img src={slide.image} alt={slide.title} className={slide.imageClass} />
              </div>

              <button
                className="ipad2026-view-details-btn"
                onClick={() => handleViewDetails(slide.productId)}
                onMouseEnter={pauseAutoplay}
                onMouseLeave={resumeAutoplay}
              >
                View Details
              </button>

              <p className="ipad2026-terms">
                *Terms and Conditions Apply. <br />
                The EMI amount may differ from person to person. <br />
                EMI offers are subject to changes without prior notice.
              </p>
            </div>
          </section>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default IpadCarousel;
